import ComponentWithFloatingIconDownload from '@/components/ComponentWithFloatingIconDownload';

export default {
  name: 'OrganicPaid',

  components: {
    ComponentWithFloatingIconDownload,
  },

  props: {
    metrics: {
      required: true,
    },
  },

  computed: {
    legacyReach() {
      const { impressionsOrganic, impressionsPaid } = this.metrics;

      return {
        organic: impressionsOrganic || 0,
        paid: impressionsPaid || 0,
      };
    },
    hasLegacyFacebookMetrics() {
      return (
        this.metrics.hasLegacyFacebookMetrics ?? !this.metrics.usesMediaViews
      );
    },
    mediaViews() {
      return {
        organic: this.metrics.viewsOrganic || 0,
        paid: this.metrics.viewsPaid || 0,
      };
    },
    usesMediaViews() {
      return Boolean(
        this.metrics.hasViewsMetric ?? this.metrics.usesMediaViews
      );
    },
    videoView() {
      const { videoViewsOrganic, videoViewsPaid } = this.metrics;

      return {
        organic: videoViewsOrganic || 0,
        paid: videoViewsPaid || 0,
      };
    },
  },
};
